import { Helmet } from "react-helmet";
import { 
  DocumentTextIcon
} from "@heroicons/react/24/outline";

// components
import { SectionHeader } from "../../components/layouts/section.header";
import { SectionSubHeader } from "../../components/layouts/section.subheader";
import { TablePartnersApplication } from "../../tables/partners.application";

export const ScreenNewPartners = () => {

  // hooks

  return (
    <>
      <Helmet>
        <title>Conference</title>
      </Helmet>
      <div className="h-screen w-full">
        <SectionHeader title='Strategic Partners Application' />

        {/* CARD SUMMARY */}
        <div className="mt-8">

          {/* TABLE CONFERENCE */}
          <div className="mt-10">

            <div className="w-full flex flex-row justify-between items-center">
              <SectionSubHeader Icon={DocumentTextIcon} title='List of application' />
            </div>

            

            <TablePartnersApplication />
          </div>

        </div>
      </div>
    </>
  );
};
